import { render, staticRenderFns } from "./CallStatusView.vue?vue&type=template&id=4385d2f1&scoped=true&lang=pug&"
import script from "./CallStatusView.vue?vue&type=script&lang=ts&"
export * from "./CallStatusView.vue?vue&type=script&lang=ts&"
import style0 from "./CallStatusView.vue?vue&type=style&index=0&id=4385d2f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4385d2f1",
  null
  
)

export default component.exports